export const ENDPOINT = "https://gv8ryursw3.execute-api.ap-northeast-1.amazonaws.com/staging/"

export const HCAPTCHA_SITEKEY = process.env.REACT_APP_HCAPTCHA_SITEKEY
